import StoryTelling from "gatsby-theme-dettol/src/components/StoryTelling/StoryTelling"

import "./StoryTellingOverride.scss"

export default StoryTelling